<div class="student-profile-card">

    <h2 class="section-header">{{ "General" | translate }}</h2>

    <div class="top-section-content">
        <div class="top-section-img-container">
            <span *ngIf="!hasAvatar" class="avatar-container">
                <img
                
                class="avatar"
                src="../../../assets/account-circle.svg"
            />
            <div class="upload-link">
                <button 
                mat-icon-button
                class="upload-text avatar-middle"
                (click)="uploadAvatar.click()"
            >
                <input hidden #uploadAvatar type="file" (change)="onUploadAvatarClick($event)"/>
                <mat-icon class="upload-icon">upload_outline</mat-icon>
                {{"Upload a new image" | translate}}
            </button>
            </div>
            </span>
            
            <span *ngIf="hasAvatar" class="avatar-container">
                <img 
                    
                    class="avatar"
                    [src]="avatarUrl | safeHtml"
                />
                <div class="upload-link">
                    <button 
                    mat-icon-button
                    class="upload-text avatar-middle"
                    (click)="uploadAvatar.click()"
                >
                    <input hidden #uploadAvatar type="file" (change)="onUploadAvatarClick($event)"/>
                    <mat-icon class="upload-icon">upload_outline</mat-icon>
                    {{"Upload a new image" | translate}}
                </button>
                </div>
            </span>
            
            <div class="upload-link">
                <button 
                    mat-icon-button
                    class="upload-text"
                    (click)="uploadAvatar.click()"
                >
                    <input hidden #uploadAvatar type="file" (change)="onUploadAvatarClick($event)"/>
                    <mat-icon class="upload-icon">upload_outline</mat-icon>
                    {{"Upload a new image" | translate}}
                </button>
            </div>
        </div>

        <div class="top-section-info">
            <div class="name">
                {{ studentProfile.firstName }} {{ studentProfile.lastName }}
            </div>

            <div class="student-tag">
                {{ "Student" | translate }}
            </div>
            <div class="info-rows">
                <div class="info-row">
                    <div class="info-row-label">
                        {{ "Pathways ID" | translate }}:
                    </div>
                    <div class="info-row-value">
                        {{ studentProfile.passId }}
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-row-label">
                        {{ "School ID" | translate }}:
                    </div>
                    <div class="info-row-value">
                        {{ studentProfile.schoolStudentNumber }}
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-row-label">
                        {{ "Phone" | translate }}:
                    </div>
                    <a
                        class="info-row-value"
                    >
                        {{ studentProfile.cellPhone | phoneFormat }}
                    </a>
                </div>
                <div class="info-row">
                    <div class="info-row-label">
                        {{ "Email" | translate }}:
                    </div>
                    <a
                        class="info-row-value green-text"
                    >
                        {{ studentProfile.email }}
                    </a>
                </div>
                <div class="info-row">
                    <div class="info-row-label">
                        {{ "Address" | translate }}:
                    </div>
                    <div class="info-row-value">
                        {{ studentProfile.address }}
                    </div>
                </div>
                <!-- <div class="info-row">
                    <div class="info-row-label">
                        {{ "Bio" | translate }}:
                    </div>
                    <div *ngIf="!isEditing">
                        <div class="info-row-value biography-row">
                            {{ biography }}
                        </div>
                        <button mat-button class="biography-edit-btn" (click)="toggleEdit()">Edit Bio</button>
                    </div>
                    <div *ngIf="isEditing">
                        <div class="info-row-value biography-row">
                            <input [(ngModel)]="biography" type="text">
                        </div>
                        <button mat-button class="biography-cancel-btn" (click)="toggleEdit()">Cancel</button>
                        <button mat-button class="biography-save-btn" (click)="saveBiography(biography)">Save</button>
                        
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    
</div>